// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"f728d41e","907":"6c6bb973"}[chunkId] + ".chunk.js";
};